import ViewTabsSection from './Component';

export default ViewTabsSection;